module.exports = ".modal-dialog {\n  width: 40%;\n  max-width: none;\n  overflow-y: auto; }\n\ntable td {\n  cursor: pointer; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/account-client/component/account-client-details/serasa-confirm/serasa-confirm.component.scss
// module id = ./src/app/account-client/component/account-client-details/serasa-confirm/serasa-confirm.component.scss
// module chunks = main